"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useDeepEqualMemo", {
    get: ()=>_useDeepEqualMemo.useDeepEqualMemo,
    enumerable: true
});
const _useDeepEqualMemo = require("./useDeepEqualMemo");
